import $ from "jquery";
import haversine from 'haversine-distance';
import Modal from 'bootstrap/js/src/modal';

const storeSelector = {
    $pageBody: undefined,
    $searchInput: undefined,
    $stores: undefined,
    $openingHoursView: undefined,
    $geolocation: undefined,
    $iFrame: undefined,
    storesList: window.stores ? window.stores : [],
    storeModal: undefined,
    cacheSelectors() {
        this.$pageBody = $(document.body);
        this.$searchInput = $('#js-storeselector__input');
        this.$stores = $('.js-filter-store');
        this.$displayNameView = $('#js-display-name-view');
        this.$addressView = $('#js-address-view');
        this.$openingHoursView = $('#js-opening-hours-view');
        this.$geolocation = $('#js-storeselector__geolocation');
        this.$iFrame = $('#js-storeselector__iframe');
        this.storeModal = $('#modal-store');
    },
    buildModal() {
        new Modal(this.storeModal[0], {
            show: true,
            focus: false,
            keyboard: true
        });
    },
    bindHandlers() {
        this.$pageBody.on('click', '.js-show-details', (event) => {
            const $parent = $(event.currentTarget).closest('.storeselector__list-entry');
            const displayName = $parent.find('.js-display-name').html();
            const address = $parent.find('.js-address').html();
            const openingHours = $parent.find('.js-opening-hours').html();
            const mapAddress = $parent.find('.js-storeselector__address').data('address');
            const iFrame = `<iframe class="storeselector__iframe"
                    src="https://maps.google.com/maps?hl=${ACC.config.language}&amp;q=${encodeURI(mapAddress)}&amp;t=&amp;z=17&amp;ie=UTF8&amp;output=embed"></iframe>`;

            this.$displayNameView.html(displayName);
            this.$addressView.html(address);
            this.$openingHoursView.html(openingHours);
            this.$iFrame.html(iFrame);
            this.storeModal.modal('show');
        });

        this.$searchInput.on('keyup', (event) => {
            // https://css-tricks.com/in-page-filtered-search-with-vanilla-javascript/
            const searchQuery = event.target.value.toLowerCase();

            this.$stores.each((index, store) => {
                const $store = $(store);
                const text2search = $store.find('.js-storeselector__address').data('address').toLowerCase();

                if (text2search.includes(searchQuery)) {
                    $store.removeClass('storeselector__list-entry--hidden');
                } else {
                    $store.addClass('storeselector__list-entry--hidden');
                }
            });
        });

        this.$geolocation.on('click', (event) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const myLocation = {latitude: position.coords.latitude, longitude: position.coords.longitude};
                        this.storesList.map((store) => {
                            const storeLocation = {latitude: store.latitude, longitude: store.longitude};
                            const storeDistance = haversine(myLocation, storeLocation) / 1000;
                            $(`#js-store-distance-${store.name}`).text(`(${storeDistance.toFixed(1)}km)`);
                            $(`#js-store-${store.name}`).css({'order': storeDistance.toFixed()});
                        });
                    },
                    (error) => {
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                console.error = "User denied the request for Geolocation.";
                                break;
                            case error.POSITION_UNAVAILABLE:
                                console.error = "Location information is unavailable.";
                                break;
                            case error.TIMEOUT:
                                console.error = "The request to get user location timed out.";
                                break;
                            case error.UNKNOWN_ERROR:
                                console.error = "An unknown error occurred.";
                                break;
                        }
                    });
            } else {
                console.log = "Geolocation is not supported by this browser.";
            }
        });
    }
};

// DOM ready
$(() => {
    if ($('#js-storeselector').length) {
        storeSelector.cacheSelectors();
        storeSelector.buildModal();
        storeSelector.bindHandlers();
    }
});

export default storeSelector;
